import Commerce from "@chec/commerce.js";

export const commerce = new Commerce(
  "pk_test_26764dea74daa1a513afd08567dc9f84dfe1c5072c523"
);
